// 브랜드 관련 문자열·링크는 이 파일 한 곳에만 둔다(goals.md).
// __BRAND__ 는 vite.config.ts의 define이 주입하는 리터럴 상수라,
// 아래 삼항 분기는 빌드 시 한쪽만 남고 반대쪽(및 그 문자열)은 esbuild가 제거(DCE)한다.
// → 익명(none) 빌드 번들에는 'My Pokerface' 같은 브랜드 문자열이 아예 포함되지 않는다.
export type BrandId = 'none' | 'mine'

interface BrandConfig {
  id: BrandId
  appName: string   // 앱 안에 표시하는 이름(익명 빌드는 평범한 업무 용어)
  brandName: string // 외부 공유용에서만 드러내는 브랜드(익명 빌드는 빈 문자열)
  contactUrl: string
  indexable: boolean
}

declare const __BRAND__: BrandId

export const BRAND: BrandConfig =
  __BRAND__ === 'mine'
    ? { id: 'mine', appName: 'My Pokerface', brandName: 'My Pokerface', contactUrl: '', indexable: true }
    : { id: 'none', appName: 'Workspace', brandName: '', contactUrl: '', indexable: false }

export const isBrandBuild = __BRAND__ === 'mine'
